import { InjectionToken, Provider } from '@angular/core';

export type AuthAppFlow = 'freight' | 'admin' | 'fleet';

export const AUTH_APP_FLOW = new InjectionToken<AuthAppFlow>('AUTH_APP_FLOW', {
  providedIn: 'root',
  factory: () => 'freight',
});

export function provideAuthAppFlow(flow: AuthAppFlow): Provider {
  return { provide: AUTH_APP_FLOW, useValue: flow };
}
